import { initialTableShow } from 'utils/settings';

export const mainTableConf = [
  {
    isSortable: true,
    field: 'maintenanceId',
    title: 'Maintenance ID',
    show: true,
    width: 417,
    valuesExport: ['maintenanceId']
  },
  {
    isSortable: true,
    field: 'cloudProvider',
    title: 'Cloud Provider',
    show: true,
    width: 164,
    valuesExport: ['cloudProvider']
  },
  {
    isSortable: true,
    field: 'providerRegionName',
    title: 'Provider Region',
    show: true,
    width: 164,
    valuesExport: ['providerRegionName']
  },
  {
    isSortable: true,
    field: 'maintenanceStatus',
    title: 'Status',
    show: true,
    width: 282,
    valuesExport: ['maintenanceStatus']
  },
  {
    isSortable: true,
    field: 'maintenanceStartTime',
    title: 'Start Time',
    show: true,
    width: 242,
    valuesExport: ['maintenanceStartTime']
  },
  {
    isSortable: true,
    field: 'maintenanceEndTime',
    title: 'End Time',
    show: true,
    width: 142,
    valuesExport: ['maintenanceEndTime']
  },
  {
    isSortable: true,
    field: 'networkIdsCount',
    title: 'Affected Network',
    show: true,
    fromToGroup: true,
    width: 222,
    valuesExport: ['networkIdsCount']
  },
  {
    isSortable: true,
    field: 'customerIdsCount',
    title: 'Affected Customers',
    show: true,
    fromToGroup: true,
    width: 222,
    valuesExport: ['customerIdsCount']
  },
  {
    isSortable: true,
    field: 'gatewayIdsCount',
    title: 'Affected Gateway',
    show: true,
    fromToGroup: true,
    width: 222,
    valuesExport: ['gatewayIdsCount']
  },
  {
    isSortable: false,
    field: 'messageIdsCount',
    title: 'Message',
    show: true,
    width: 222,
    valuesExport: ['messageIdsCount']
  },
  {
    isSortable: true,
    field: 'maintenanceSubject',
    title: 'Subject',
    show: true,
    width: 126,
    valuesExport: ['maintenanceSubject']
  },
  {
    isSortable: true,
    field: 'alertCreatedAt',
    title: 'Created At',
    show: true,
    width: 142,
    valuesExport: ['alertCreatedAt']
  }
];

export const subTableConf = [
  {
    field: 'companyName',
    title: 'Customer Name'
  },
  {
    field: 'networkId',
    title: 'Network Id'
  },
  {
    field: 'gatewayId',
    title: 'Gateway Id'
  },
  {
    field: 'isTunnelExist',
    title: 'Tunnels'
  }
];

export const defaultFilters = {
  search: '',
  cloudProvider: [],
  providerRegionName: [],
  maintenanceStartTime: [],
  maintenanceEndTime: [],
  maintenanceStatus: ['ongoing', 'scheduled'],
  alertCreatedAt: { startDate: null, endDate: null }
};

export const defaultNavigation = {
  fieldName: 'maintenanceStartTime',
  direction: initialTableShow.direction,
  currentPage: initialTableShow.currentPage,
  itemsPerPage: initialTableShow.itemsPerPage,
  customerIdsCount: { from: '', to: '' },
  networkIdsCount: { from: '', to: '' },
  gatewayIdsCount: { from: '', to: '' }
};

export const exportConfigMaintenance = {
  exportUrl: '/rd/maintenance/export',
  exportName: 'Maintenance',
  exportFormat: 'zip'
};
